// Suppress known React 18 + Radix UI callback ref warnings
// This is a known issue with certain versions of Radix UI components
// and doesn't affect functionality

const originalConsoleError = console.error;

console.error = (...args) => {
  // Suppress the specific callback ref warning from Radix UI
  if (
    typeof args[0] === 'string' &&
    args[0].includes('Unexpected return value from a callback ref')
  ) {
    return;
  }
  
  // Allow all other console errors through
  originalConsoleError.apply(console, args);
};

export {};